export const styles = {
  component: {
    fontSize: "16px",
  },
  notes: {
    fontFamily: "sans-serif",
  },
};
